import React from "react";

import image from "Vendor_resources/images/allprojects-blank.svg";

const CreateNewProject = () => <img src={image} alt="all projects blank" />;

export default CreateNewProject;
